import { render, staticRenderFns } from "./paivittaiset-merkinnat.vue?vue&type=template&id=0e8a6a9a&scoped=true&"
import script from "./paivittaiset-merkinnat.vue?vue&type=script&lang=ts&"
export * from "./paivittaiset-merkinnat.vue?vue&type=script&lang=ts&"
import style0 from "./paivittaiset-merkinnat.vue?vue&type=style&index=0&id=0e8a6a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8a6a9a",
  null
  
)

export default component.exports